module.exports = __webpack_public_path__ + "img/img2.37465c11.png";